<template>
  <div>
    <ToplistingPromotionCards
      v-if="!isModalReadOnly"
      :modelValue="modelValue"
      :radioName="radioName"
      :hidePromotionTypeHeader="hidePromotionTypeHeader"
      :hideRecommendedBadge="hideRecommendedBadge"
      :useImprovedBenefitLines="useImprovedBenefitLines"
      :cards="cards"
      @update:modelValue="onUpdate"
    >
      <template #afterPromotionDescription>
        <slot name="afterPromotionDescription" />
      </template>
      <template #pricing-TOP_ABO>
        <slot name="pricing-TOP_ABO" />
      </template>
      <template #pricing-REGIONAL_HIGHLIGHT>
        <slot name="pricing-REGIONAL_HIGHLIGHT" />
      </template>
      <template #pricing-PROJECT_BOOST>
        <slot name="pricing-PROJECT_BOOST" />
      </template>
      <template #pricing-TOP>
        <slot name="pricing-TOP" />
      </template>
      <template #pricing-PREMIUM>
        <slot name="pricing-PREMIUM" />
      </template>
      <template #pricing-LIFETIME>
        <slot name="pricing-LIFETIME" />
      </template>
    </ToplistingPromotionCards>
    <ToplistingPromotionCards
      v-else
      :modelValue="modelValue"
      :radioName="radioName"
      :hidePromotionTypeHeader="hidePromotionTypeHeader"
      :hideRecommendedBadge="hideRecommendedBadge"
      :useImprovedBenefitLines="useImprovedBenefitLines"
      :cards="readonlyCards"
      @update:modelValue="onUpdate"
    >
      <template #afterPromotionDescription>
        <slot name="afterPromotionDescription" />
      </template>
      <template #pricing-LIFETIME>
        <slot name="pricing-LIFETIME" />
      </template>
    </ToplistingPromotionCards>
  </div>
</template>

<script lang="ts" setup>
import ToplistingPromotionCards from '@/components/ToplistingPromotionCards/ToplistingPromotionCards.vue';
import type { ToplistingPromotionCardConfig } from '@/components/ToplistingPromotionCards/types';

withDefaults(
  defineProps<{
    modelValue: string;
    cards: ToplistingPromotionCardConfig[];
    readonlyCards?: ToplistingPromotionCardConfig[];
    isModalReadOnly?: boolean;
    useImprovedBenefitLines?: boolean;
    hidePromotionTypeHeader?: boolean;
    hideRecommendedBadge?: boolean;
    radioName?: string;
  }>(),
  {
    readonlyCards: () => [],
    isModalReadOnly: false,
    useImprovedBenefitLines: true,
    hidePromotionTypeHeader: false,
    hideRecommendedBadge: false,
    radioName: 'toplistingVariant',
  },
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();

function onUpdate(value: string): void {
  emit('update:modelValue', value);
}
</script>
